import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from './provider';
export const provide = ((stores, fallback) => (Component) => props => (_jsx(Provider, Object.assign({}, stores, { fallback: fallback }, { children: _jsx(Component, Object.assign({}, props), void 0) }), void 0)));
//# sourceMappingURL=provide.js.map